import api from '../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormBudget from './Form/FormBudget'

function NewBudget({ btCancelAction, handleOnSuccess, allowSellerSelect }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    

    

    async function registerBudget(budget) {
        let msgType = 'success'

        const data = await api.post('/order/budget/new', budget, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormBudget title="Novo Orçamento" handleSubmit={registerBudget} btCancelAction={btCancelAction} btnText="Cadastrar" allowSellerSelect={allowSellerSelect} />
    )
}

export default NewBudget